<template>
 <div>
      <zj-layout-container>
        <div style="height:50%">
          <div style="float:left;height:100%;width:45%;"><OpinionHotWordsView></OpinionHotWordsView></div>
          <div style="float:left;height:100%;width:45%;"><OpinionMediaView></OpinionMediaView></div>
        </div>
        <div style="height:50%">
           <div  style="height:90%;"><OpinionRealTimeView></OpinionRealTimeView></div>
        </div>
      </zj-layout-container>
  </div>
</template>
<script>

import OpinionHotWordsView from "./OpinionHotWords";
import OpinionMediaView from "./OpinionMedia";
import OpinionRealTimeView from "./OpinionRealTime";

export default {
  name: "OpinionAnalysisManager",
  controller: "UI",
  action: "OpinionAnalysisManager",
   components: {
    OpinionHotWordsView,
    OpinionMediaView,
    OpinionRealTimeView
  },
}

</script>